export default function CloseIcon() {
	return (
		<svg viewBox="0 0 100 100">
			<path d="M88.4.8q-3-.75-5 1-2.2 1.25-4.45 3.45L50.15 34.3 20.9 5q-2-1.95-4.45-3.45-2-1.5-5-1-2.7.75-6.7 4.7Q1.05 9 .3 11.7q-.5 3 1 5 1.5 2.45 3.45 4.45l29.3 29.3-28.8 28.5q-1.95 2-3.7 4.45-1.5 2-1 5 .75 2.7 4.7 6.7 4 3.7 6.7 4.45 2.75.5 4.7-1 2.5-1.5 4.5-3.45L49.9 66.3l28.55 28.55q2.25 2.2 4.7 3.7 2 1.5 5 1 2.7-.75 6.45-4.45 3.95-4 4.7-6.7.5-3-1-5-1.5-2.45-3.7-4.7L66.05 50.2l28.8-28.8q2.2-2.25 3.7-4.45 1.5-2.25 1.25-5-.75-2.95-4.7-6.7-4-3.95-6.7-4.45Z" />
		</svg>
	)
}
